export const getChoiceKey = (choice) => choice?.key;

export const getChoiceValue = (choice) => choice?.value;

export const checkboxIsRequired = (value) => value !== "0";
